var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.allows_crud)?_c('b-button',{staticClass:"mt-1",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){return _vm.createdOption()}}},[_vm._v(" + Agregar alternativa ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }